"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _rfdc = /*#__PURE__*/ _interop_require_default(require("rfdc"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const deepClone = (0, _rfdc.default)();
const _default = deepClone;
